import { render } from "./ATSPanel.vue?vue&type=template&id=90b35642&scoped=true"
import script from "./ATSPanel.vue?vue&type=script&lang=ts"
export * from "./ATSPanel.vue?vue&type=script&lang=ts"

import "./ATSPanel.vue?vue&type=style&index=0&id=90b35642&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-90b35642"

export default script